webpackJsonp([53566712009029],{

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-gov-1.b4b0ea39.jpg";

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-gov-2.62f18913.jpg";

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-gov-3.6186db9f.jpg";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-gov-4.160357cb.jpg";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FOI-gov.cf28b754.png";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Hero-gov.a016ac44.jpg";

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.GovQuery = undefined;
	
	var _Grid = __webpack_require__(5);
	
	var _Hero = __webpack_require__(13);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ProductBar = __webpack_require__(14);
	
	var _ProductBar2 = _interopRequireDefault(_ProductBar);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _DividerImage = __webpack_require__(17);
	
	var _DividerImage2 = _interopRequireDefault(_DividerImage);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OrderButton = __webpack_require__(18);
	
	var _OrderButton2 = _interopRequireDefault(_OrderButton);
	
	var _PricingContainer = __webpack_require__(19);
	
	var _PricingContainer2 = _interopRequireDefault(_PricingContainer);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgImage = __webpack_require__(130);
	
	var _SvgImage2 = _interopRequireDefault(_SvgImage);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _Video = __webpack_require__(50);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _HeroGov = __webpack_require__(493);
	
	var _HeroGov2 = _interopRequireDefault(_HeroGov);
	
	var _FOIGov = __webpack_require__(484);
	
	var _FOIGov2 = _interopRequireDefault(_FOIGov);
	
	var _BackgroundGov = __webpack_require__(466);
	
	var _BackgroundGov2 = _interopRequireDefault(_BackgroundGov);
	
	var _BackgroundGov3 = __webpack_require__(467);
	
	var _BackgroundGov4 = _interopRequireDefault(_BackgroundGov3);
	
	var _BackgroundGov5 = __webpack_require__(468);
	
	var _BackgroundGov6 = _interopRequireDefault(_BackgroundGov5);
	
	var _BackgroundGov7 = __webpack_require__(469);
	
	var _BackgroundGov8 = _interopRequireDefault(_BackgroundGov7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    navcolour: {
	      backgroundColor: theme.colours.products.gov
	    },
	    bulletLists: {
	      textAlign: "left",
	      maxWidth: "30vw",
	      "@media (max-width: 823px)": {
	        maxWidth: "80vw"
	      },
	      "& h2": {
	        fontSize: "2.2rem",
	        fontWeight: 100,
	        margin: "1rem",
	        textAlign: "center"
	      }
	    },
	    bulletSection: {
	      width: "100%",
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    bulletSectionMobile: {
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    },
	    text: {
	      width: "50vw",
	      paddingLeft: "2.5rem",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        margin: "1rem",
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "2.2rem"
	        }
	      }
	    },
	    video: {
	      width: "50vw",
	      height: "40vh",
	      "@media (max-width: 414px)": {
	        marginTop: "0.5rem",
	        width: "90vw",
	        height: "28vh"
	      },
	      "@media (min-width: 415px) and (max-width: 823px)": {
	        height: "90vh",
	        width: "74vw"
	      },
	      "@media (min-width: 767px) and (max-width: 769px)": {
	        height: "30vh"
	      },
	      "@media (min-width: 1023px) and (max-width: 1025px) and (min-height: 1365px)": {
	        height: "30vh",
	        width: "70vw"
	      }
	    },
	    image: {
	      width: "500px",
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    mobileImage: {
	      width: "325px",
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    },
	    contentBox: {
	      minHeight: "100vh"
	    },
	    pricingContainer: {
	      width: "100%"
	    },
	    pricing: {
	      width: "35vw",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        fontWeight: 400,
	        margin: "1rem",
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      }
	    },
	    pricingParagraph: {
	      maxWidth: "568px"
	    }
	  };
	};
	
	var NavTabs = [{
	  tabLink: "#video",
	  tabName: "Video"
	}, {
	  tabLink: "#features",
	  tabName: "Features"
	}, {
	  tabLink: "#pricing",
	  tabName: "Pricing"
	}, {
	  tabLink: "/contact",
	  tabName: "Support"
	}];
	
	var GovPage = function GovPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ProductBar2.default,
	      {
	        className: classes.navcolour,
	        logoLink: "/gov",
	        logoSrc: "/gov-logo.svg"
	      },
	      NavTabs.map(function (tab) {
	        return _react2.default.createElement(_ProductBar.Tab, { key: tab.tabName, tabLink: tab.tabLink, tabName: tab.tabName });
	      })
	    ),
	    _react2.default.createElement(
	      _Hero2.default,
	      { hero: _HeroGov2.default, withBar: true },
	      _react2.default.createElement(
	        _Grid.Row,
	        { top: true, center: true },
	        _react2.default.createElement(
	          _Hero.HeroText,
	          null,
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.HeroText.html })
	        )
	      )
	    ),
	    _react2.default.createElement("div", { id: "video" }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_Video2.default, {
	          src: "//www.youtube.com/embed/0y_gRbWLuSM?rel=0&showinfo=0",
	          className: classes.video,
	          name: "Gov Video"
	        })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundGov2.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "features" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.bulletSection },
	        _react2.default.createElement(
	          _Grid.Row,
	          { around: true },
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(_SvgImage2.default, { src: "/record-icon.svg" }),
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.bulletLists },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentTopLeft.html })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(_SvgImage2.default, { src: "/action-icon.svg" }),
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.bulletLists },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentTopRight.html })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          { around: true },
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(_SvgImage2.default, { src: "/track-icon.svg" }),
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.bulletLists },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentBottomLeft.html })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(_SvgImage2.default, { src: "/analyse-icon.svg" }),
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.bulletLists },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentBottomRight.html })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.bulletSectionMobile },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(_SvgImage2.default, { src: "/record-icon.svg" }),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.bulletLists },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentTopLeft.html })
	          ),
	          _react2.default.createElement(_SvgImage2.default, { src: "/action-icon.svg" }),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.bulletLists },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentTopRight.html })
	          ),
	          _react2.default.createElement(_SvgImage2.default, { src: "/track-icon.svg" }),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.bulletLists },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentBottomLeft.html })
	          ),
	          _react2.default.createElement(_SvgImage2.default, { src: "/analyse-icon.svg" }),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.bulletLists },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentBottomRight.html })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundGov4.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _FOIGov2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _FOIGov2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundGov6.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        "div",
	        { className: classes.bulletSection },
	        _react2.default.createElement(
	          _Grid.Row,
	          { around: true },
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(_SvgImage2.default, { src: "/cloud-icon.svg" }),
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.bulletLists },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentFirstColumn.html })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(_SvgImage2.default, { src: "/padlock-icon.svg" }),
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.bulletLists },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentSecondColumn.html })
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(_SvgImage2.default, { src: "/compatibility-icon.svg" }),
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.bulletLists },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentThirdColumn.html })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.bulletSectionMobile },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(_SvgImage2.default, { src: "/cloud-icon.svg" }),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.bulletLists },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentFirstColumn.html })
	          ),
	          _react2.default.createElement(_SvgImage2.default, { src: "/padlock-icon.svg" }),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.bulletLists },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentSecondColumn.html })
	          ),
	          _react2.default.createElement(_SvgImage2.default, { src: "/compatibility-icon.svg" }),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.bulletLists },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentThirdColumn.html })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundGov8.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "pricing" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.pricing },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            {
	              className: classes.text + " " + classes.pricingParagraph
	            },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.PricingSection.html })
	          )
	        ),
	        _react2.default.createElement(
	          _PricingContainer2.default,
	          null,
	          _react2.default.createElement(_HtmlContainer2.default, {
	            className: classes.text,
	            content: data.PricingChecklist.html
	          })
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            {
	              className: classes.text + " " + classes.pricingParagraph
	            },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.PricingSecondSection.html })
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(_OrderButton2.default, {
	            eventlabel: "Clicked Gov buy button",
	            mailinfo: "mailto:sales@electedtechnologies.com?subject=Caseworker.gov Sales Enquiry",
	            label: "Contact Us",
	            phonenumber: "0333 344 1225"
	          })
	        )
	      )
	    )
	  );
	};
	
	GovPage.propTypes = {
	  classes: _propTypes2.default.object,
	  data: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(GovPage);
	
	/* global graphql */
	
	var GovQuery = exports.GovQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gov-jsx-6bc49c648646065ba3b5.js